import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} sx={{backgroundColor:"rgba(5,0,35,1)",backgroundImage:'none'}}/>
        </Draggable>
    );
}

export default function DraggableDialog({children,title,onClose}) {
    return (
        <Dialog
                open={true}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
        >
                <DialogTitle style={{ cursor: 'move' }} className="draggable-dialog-title">
                    {title}
                    <a
                        onClick={onClose}
                        style={{cursor: "pointer"}}
                        className="close_btn"
                    >
                        &times;
                    </a>
                </DialogTitle>

                {children}
            </Dialog>

    );
}
